module.exports = __webpack_public_path__ + "static/img/抱歉300.3cb713eb.png";